export default __webpack_public_path__ + "9b55444151d93b4f8c44bc9259f94252.png";